import {
  type Camera,
  HalfFloatType,
  type Scene,
  type WebGLRenderer,
  WebGLRenderTarget,
} from "three";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass.js";

/** Resolves scene MSAA once, without multisampling any fullscreen passes. */
export class ProductViewerBeautyPass extends RenderPass {
  readonly target: WebGLRenderTarget;

  constructor(scene: Scene, camera: Camera, width: number, height: number) {
    super(scene, camera);
    this.target = new WebGLRenderTarget(width, height, {
      type: HalfFloatType,
      samples: 4,
      resolveDepthBuffer: false,
    });
    this.target.texture.name = "ProductViewer.beauty";
  }

  override setSize(width: number, height: number): void {
    this.target.setSize(width, height);
  }

  override render(
    renderer: WebGLRenderer,
    writeBuffer: WebGLRenderTarget,
    _readBuffer: WebGLRenderTarget,
    deltaTime: number,
    maskActive: boolean,
  ): void {
    super.render(renderer, writeBuffer, this.target, deltaTime, maskActive);
  }

  override dispose(): void {
    this.target.dispose();
  }
}
